import React from "react";
import { Static } from "../interfaces/Static";

type SelectType = {
  items: Static[] | string[];
  value: string;
  placeholder: string;
  required?: boolean;
  label?: string;
  onSelect: (selectedItem: string) => void;
};

const CustomSelect = ({
  items,
  value,
  placeholder,
  required,
  label,
  onSelect,
}: SelectType) => {
  const updatedPlaceholder = required ? `${placeholder} *` : placeholder;

  return (
    <>
      {label && (
        <div className="mb-2">
          {label} {required ? "*" : ""}
        </div>
      )}
      <select
        className="select select-bordered min-w-full mb-4 w-full rounded-none"
        onChange={(e) => onSelect(e.target.value)}
      >
        <option
          className="overflow-auto"
          value=""
          disabled
          selected={value === ""}
        >
          {updatedPlaceholder}
        </option>

        {items.map((item, index) => (
          <option
            key={`${item}-${index}`}
            selected={
              typeof item === "string"
                ? item === value
                : item.description === value
            }
          >
            {typeof item === "string" ? item : item.description}
          </option>
        ))}
      </select>
    </>
  );
};

export default CustomSelect;
